/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				$('.navbar-toggler').magnificPopup({
					midClick: true,
					fixedContentPos: true,
					fixedBgPos: true,
					callbacks: {
						beforeOpen: function() {
							Sage.home.setup();
						},
						afterClose: function() {
							Sage.home.setup();
						},
						resize: function() {
							if ( $(window).width() > 767 ) {
								$.magnificPopup.close();
							}
							Sage.home.setup();
						},
						markupParse: function() {
							Sage.home.setup();
						},
					}
				});
				$('body, body.archive main.main').css( {
					'min-height': window.innerHeight
				} );
				$(window).resize( function () {
					$('body, body.archive main.main').removeAttr('style');
					$('body, body.archive main.main').css( {
						'min-height': window.innerHeight
					} );
				} );
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			setup: function () {
				var mql = window.matchMedia("(orientation: portrait)");
				var page_content = $('.page-content');
				page_content.removeAttr('style');
				page_content.find('.flexslider .slides li').css({
					'height': 'auto',
					'overflow': 'hidden'
				});
				/*
				page_content.find('.flexslider .slides li img').removeClass('responsiveH').removeClass('responsiveW');
				page_content.css({
					'height': window.innerHeight
				});
				page_content.find('.flexslider .slides li').css({
					'height': window.innerHeight - $('.page-header').height()
				});
				if(mql.matches) {
					page_content.find('.flexslider .slides li img').addClass('responsiveH');
					if ( window.innerWidth > page_content.find('.flexslider .slides li img').width() ) {
						page_content.find('.flexslider .slides li img').removeClass('responsiveH').addClass('responsiveW');
					}
				}
				else {
					page_content.find('.flexslider .slides li img').addClass('responsiveW');
					if ( window.innerHeight > page_content.find('.flexslider .slides li img').height() ) {
						page_content.find('.flexslider .slides li img').removeClass('responsiveW').addClass('responsiveH');
					}
				}
				*/
			},
			init: function() {
				// JavaScript to be fired on the home page
				this.setup();
				setTimeout( this.setup, 500 );
				setTimeout( this.setup, 1500 );
				setTimeout( this.setup, 2500 );
				$(window).resize( this.setup );
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'contacto': {
			validateNumber: function (event) {
				if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 || event.keyCode === 13 ||
					 // Allow: Ctrl+A
					 (event.keyCode === 65 && event.ctrlKey === true) ||
					 // Allow: home, end, left, right
					 (event.keyCode >= 35 && event.keyCode <= 39)) {
					 // let it happen, don't do anything
					 return;
				 }
				 else {
					 // Ensure that it is a number and stop the keypress
					 if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
						 event.preventDefault();
					 }
				 }
			},
			validateEmail: function (email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			},
			submit_error: function( error_message, $form ) {
				$( '.message-result' ).remove();
				$form.prepend( error_message );
				$form.removeClass( 'processing' );
			},
			init: function() {
				// JavaScript to be fired on the about us page
				var _this = this;
				// JavaScript to be fired on the about us page
				$(".onlyNumber").keydown( _this.validateNumber );
				$('#form_contact').submit( function (e) {
					e.preventDefault();
					var $form = $( this );
					if ( $form.hasClass('processing') ) {
						return;
					}
					$form.addClass( 'processing' );
					var existsError = false;
					$form.find('.form-control').each( function( index, _control ) {
						var control = $( _control );
						control.removeClass('has-error').parent().removeClass('has-error');
						if ( control.hasClass('required') && ( !control.val() || control.val() === -1 ) ){
							control.addClass('has-error').parent().addClass('has-error');
							existsError = true;
						}
						else{
							control.removeClass('has-error');
							if ( control.hasClass('email') && ! _this.validateEmail( control.val() ) ) {
								control.addClass('has-error').parent().addClass('has-error');
								existsError = true;
							}
						}
					} );
					if ( existsError ) {
						$form.removeClass( 'processing' );
						return;
					}

					$.ajax({
						type:		'POST',
						url:		ajax_object.ajax_url,
						data:		$form.serialize(),
						dataType:	'json',
						success:	function( result ) {
							try{
								console.log( result );
								if ( result.result === 'success' ) {
									$form.removeClass( 'processing' );
									if ( result.messages ) {
										_this.submit_error( result.messages, $form );
									}
									$form[0].reset();
									setTimeout( function () {
										$.magnificPopup.close();
									}, 1500 );
									return;
								} else if ( result.result === 'failure' ) {
									throw 'Result failure';
								} else {
									throw 'Invalid response';
								}
							} catch( err ){
								_this.submit_error( '<div class="message-result error">' + site_params.i18n_form_error + '</div>', $form );
								$form.removeClass( 'processing' );
							}
						},
						error:	function( jqXHR, textStatus, errorThrown ) {
							_this.submit_error( '<div class="message-result error">' + site_params.i18n_form_error + '</div>', $form );
							$form.removeClass( 'processing' );
						}
					});

				} );
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
